import { CaseFlagModel } from './caseFlagModel';

export class CaseFlagAddModel extends CaseFlagModel{
}
